export default [
  {
    path: '/usuarios',
    component: () => import('@/modules/usuarios/views/pages/Users.vue'),
    meta: {
      title: 'Usuários',
      pagePermission: 'usuarios/editar',
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Usuários',
          pathName: null,
        },
      ],
    },
  },
]
